import styled from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import { Colors, Fonts, Metrics } from 'APP/Themes'

export const IconStyle = {
  paddingRight: Metrics.baseMargin / 1.6,
}

export const CopyStyles = {
  ...Fonts.style.body,
  color: Colors.text,
}

export const SyncCopyStyles = {
  ...Fonts.style.body,
  color: Colors.text,
  p: {
    marginBottom: 0,
  },
}

export const CtaStyle = {
  marginTop: Metrics.baseMargin / 2,
  marginHorizontal: 0,
  marginBottom: 0,
}

export const BannerContainer = styled.View`
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.bannerBg};
`

export const TitleContainer = styled.View`
  flex-direction: row;
`

export const Title = styled(Typography)`
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

export const CopyContainer = styled.View`
  flex-direction: row;
  align-items: center;
`
